var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavacscriptIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_56_176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 90,
    height: 90,
    rx: 20,
    fill: "url(#paint0_linear_56_176)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_56_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.75 42.75C55.75 40.9598 56.4612 39.2429 57.727 37.977C58.9929 36.7112 60.7098 36 62.5 36H69.25C69.8467 36 70.419 36.2371 70.841 36.659C71.2629 37.081 71.5 37.6533 71.5 38.25C71.5 38.8467 71.2629 39.419 70.841 39.841C70.419 40.2629 69.8467 40.5 69.25 40.5H62.5C61.9033 40.5 61.331 40.7371 60.909 41.159C60.4871 41.581 60.25 42.1533 60.25 42.75V47.25C60.25 47.8467 60.4871 48.419 60.909 48.841C61.331 49.2629 61.9033 49.5 62.5 49.5H64.75C66.5402 49.5 68.2571 50.2112 69.523 51.477C70.7888 52.7429 71.5 54.4598 71.5 56.25V60.75C71.5 62.5402 70.7888 64.2571 69.523 65.523C68.2571 66.7888 66.5402 67.5 64.75 67.5H58C57.4033 67.5 56.831 67.2629 56.409 66.841C55.9871 66.419 55.75 65.8467 55.75 65.25C55.75 64.6533 55.9871 64.081 56.409 63.659C56.831 63.2371 57.4033 63 58 63H64.75C65.3467 63 65.919 62.7629 66.341 62.341C66.7629 61.919 67 61.3467 67 60.75V56.25C67 55.6533 66.7629 55.081 66.341 54.659C65.919 54.2371 65.3467 54 64.75 54H62.5C60.7098 54 58.9929 53.2888 57.727 52.023C56.4612 50.7571 55.75 49.0402 55.75 47.25V42.75ZM53.5 38.25C53.5 37.6533 53.2629 37.081 52.841 36.659C52.419 36.2371 51.8467 36 51.25 36C50.6533 36 50.081 36.2371 49.659 36.659C49.2371 37.081 49 37.6533 49 38.25V60.75C49 61.3467 48.7629 61.919 48.341 62.341C47.919 62.7629 47.3467 63 46.75 63H42.25C41.6533 63 41.081 63.2371 40.659 63.659C40.2371 64.081 40 64.6533 40 65.25C40 65.8467 40.2371 66.419 40.659 66.841C41.081 67.2629 41.6533 67.5 42.25 67.5H46.75C48.5402 67.5 50.2571 66.7888 51.523 65.523C52.7888 64.2571 53.5 62.5402 53.5 60.75V38.25ZM17.5 27V63C17.5 66.5804 18.9223 70.0142 21.4541 72.5459C23.9858 75.0777 27.4196 76.5 31 76.5H67C70.5804 76.5 74.0142 75.0777 76.5459 72.5459C79.0777 70.0142 80.5 66.5804 80.5 63V27C80.5 23.4196 79.0777 19.9858 76.5459 17.4541C74.0142 14.9223 70.5804 13.5 67 13.5H31C27.4196 13.5 23.9858 14.9223 21.4541 17.4541C18.9223 19.9858 17.5 23.4196 17.5 27ZM31 18H67C69.3869 18 71.6761 18.9482 73.364 20.636C75.0518 22.3239 76 24.6131 76 27V63C76 65.3869 75.0518 67.6761 73.364 69.364C71.6761 71.0518 69.3869 72 67 72H31C28.6131 72 26.3239 71.0518 24.636 69.364C22.9482 67.6761 22 65.3869 22 63V27C22 24.6131 22.9482 22.3239 24.636 20.636C26.3239 18.9482 28.6131 18 31 18Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_56_176",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56_176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_56_176",
    x: 13.5,
    y: 13.5,
    width: 71,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56_176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56_176",
    x1: 49,
    y1: 0,
    x2: 49,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavacscriptIcon);
export default __webpack_public_path__ + "static/media/javacscript_icon.af7c5df72bf2a7afc7edf2a5eae8e08b.svg";
export { ForwardRef as ReactComponent };